<div>
  <h4 translate>API_SETTINGS</h4>
</div>
<hr />
<div>
  <span class="font-italic small mb-2 d-inline-block" translate>API_SETTINGS_LONG_DESCRIPTION</span>
</div>
@if (apiConfigurations) {
  <div class="configs">
    <div class="row">
      <div class="col-12 col-xl-6">
        <lib-gung-checkbox-input-horizontal
          [(ngModel)]="apiConfigurations.activated"
          gungTranslate="{{ 'ACTIVED' | translate }}"
        />
      </div>
      @if (apiConfigurations.activated) {
        <div class="col-12 col-xl-6">
          <lib-gung-number-input-horizontal
            [(ngModel)]="apiConfigurations.batchSize"
            gungTranslate="{{ 'BATCH_SIZE' | translate }}"
          />
        </div>
      }
    </div>

    @if (apiConfigurations.activated) {
      <div class="row">
        <div class="col-12 col-xl-6">
          <div class="mt-4">
            <strong translate>ENTITIES</strong
            ><i class="ml-2 fal fa-question-circle" ngbTooltip="{{ 'API_ENTITY_TOOLTIP' | translate }}"></i>
          </div>
          @for (entity of apiConfigurations.additionalEntities; track entity.entity; let j = $index) {
            <div class="row">
              <div class="col-5">
                <lib-gung-text-input gungTranslate="{{ 'entity' | translate }}" [(ngModel)]="entity.entity" />
              </div>
              <div class="col-5">
                <lib-gung-text-input
                  gungTranslate="{{ 'RELATED_MAIN_ENTITY' | translate }}"
                  [(ngModel)]="entity.relatedMainEntity"
                />
              </div>
              <div class="col-2 d-flex remove-div justify-content-center flex-wrap align-self-center">
                <i (click)="removeAdditionalEntities(j)" class="fa-solid fa-trash"></i>
              </div>
            </div>
            <hr />
          }
          <gung-button
            classes="btn-primary btn-sm "
            label="{{ 'ADD_ENTITY' | translate }}"
            [onClick]="addEntity.bind(this)"
          />
        </div>
        <div class="col-12 col-xl-6">
          <div class="mt-4">
            <strong translate>PUSH_TRANSFORMERS</strong
            ><i class="ml-2 fal fa-question-circle" ngbTooltip="{{ 'API_PUSH_TRANSFORMERS_TOOLTIP' | translate }}"></i>
          </div>
          @for (entity of pushTransformers; track entity.entity; let i = $index) {
            <div class="row">
              <div class="col-5">
                <lib-gung-text-input gungTranslate="{{ 'ENTITY' | translate }}" [(ngModel)]="entity.entity" />
              </div>
              <div class="col-5">
                <lib-gung-text-input gungTranslate="{{ 'VALUE' | translate }}" [(ngModel)]="entity.value" />
              </div>

              <div class="col-2 d-flex remove-div justify-content-center flex-wrap align-self-center">
                <i (click)="removePushTransformers(i)" class="fa-solid fa-trash"></i>
              </div>
            </div>

            <hr />
          }
          <gung-button
            classes="btn-primary btn-sm "
            label="{{ 'ADD_TRANSFORMERS' | translate }}"
            [onClick]="addPushTransformers.bind(this)"
          />
        </div>
      </div>
    }
  </div>
  <div class="text-right">
    <gung-button classes="btn-primary btn" label="{{ 'SAVE' | translate }}" [onClick]="save.bind(this)" />
  </div>
} @else {
  <div class="text-center">
    <div class="spinner-grow" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
}
